/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Crisp_Emu_ScanInputs */

const en_wide_crisp_emu_scan = /** @type {(inputs: Wide_Crisp_Emu_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No segments shared`)
};

const de_wide_crisp_emu_scan = /** @type {(inputs: Wide_Crisp_Emu_ScanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Segmente geteilt`)
};

/**
* | output |
* | --- |
* | "No segments shared" |
*
* @param {Wide_Crisp_Emu_ScanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wide_crisp_emu_scan = /** @type {((inputs?: Wide_Crisp_Emu_ScanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Crisp_Emu_ScanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wide_crisp_emu_scan(inputs)
	return de_wide_crisp_emu_scan(inputs)
});